/* ============================================================
   SINGSPACE ADMIN - QR CODE WHATSAPP (Sobre)
   ============================================================ */

import { QrCode } from 'lucide-react';
import { SessionStatus } from '../../types/whatsapp.types';

interface QRCodeCardProps {
  sessionStatus: SessionStatus;
}

export function QRCodeCard({ sessionStatus }: QRCodeCardProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-center p-8 bg-slate-50 rounded-lg border border-slate-200">
        {sessionStatus === 'scanning' ? (
          <div className="w-48 h-48 bg-white rounded-lg border-2 border-slate-300 flex items-center justify-center">
            <QrCode size={120} className="text-slate-400" />
          </div>
        ) : (
          <div className="w-48 h-48 bg-slate-100 rounded-lg border-2 border-dashed border-slate-300 flex items-center justify-center">
            <QrCode size={80} className="text-slate-300" />
          </div>
        )}
      </div>

      <div className="space-y-2 text-xs text-slate-600">
        <p>
          <span className="font-medium">1.</span> Ouvrez WhatsApp sur votre téléphone
        </p>
        <p>
          <span className="font-medium">2.</span> Accédez à Menu → Appareils liés
        </p>
        <p>
          <span className="font-medium">3.</span> Scannez le code QR affiché
        </p>
      </div>
    </div>
  );
}
